const controls = Array.from(document.querySelectorAll('[data-action*=":"]'));
for (const control of controls) {
  const { action } = control.dataset;
  const [ operation, id ] = action.split(':');
  control.addEventListener('click', e => {
    e.preventDefault();
    const target = document.getElementById(id);
    target[operation]();
  });
}

document.addEventListener('click', e => {
  const { target } = e;
  if (target.nodeName === 'DIALOG') {
    target.close();
  }
});